/**
 * This directive, when applied to an element, makes all links inside the
 * element open in a new tab when clicked.
 *
 * @ngdoc directive
 */
class NewTabAnchorsDirective {

    constructor() {
        this.restrict = 'A';
    }

    link(scope, element) {
        scope.$watch(() => element.children().length, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                element.find('a').attr('target', '_blank');
            }
        });
    }

    static factory() {
        return new NewTabAnchorsDirective();
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NewTabAnchorsDirective.factory.$inject = [];

export default NewTabAnchorsDirective.factory;
